import { CoreError } from './errors'
import { parseFiscalYear } from './fiscal-year'

/**
 * Document numbers: {PREFIX}-{COUNTER}-{FY without '/'}-{SEQ padded to 5}.
 * Must match public.format_doc_number() in the database.
 *   formatDocNumber('INV', 'A', '2082/83', 42) === 'INV-A-208283-00042'
 */
export function formatDocNumber(
  prefix: string,
  counterCode: string,
  fiscalYear: string,
  seq: number,
): string {
  if (!/^[A-Z0-9]{1,8}$/.test(prefix))
    throw new CoreError('invalid_input', `bad prefix "${prefix}"`)
  if (!/^[A-Z0-9]{1,6}$/.test(counterCode))
    throw new CoreError('invalid_input', `bad counter code "${counterCode}"`)
  parseFiscalYear(fiscalYear)
  if (!Number.isSafeInteger(seq) || seq < 1)
    throw new CoreError('invalid_input', 'seq must be a positive integer')
  return `${prefix}-${counterCode}-${fiscalYear.replace('/', '')}-${String(seq).padStart(5, '0')}`
}

export interface ParsedDocNumber {
  prefix: string
  counterCode: string
  fiscalYear: string
  seq: number
}

export function parseDocNumber(number: string): ParsedDocNumber {
  const match = /^([A-Z0-9]{1,8})-([A-Z0-9]{1,6})-(\d{4})(\d{2})-(\d{5,})$/.exec(number)
  if (!match) throw new CoreError('invalid_number', `"${number}" is not a document number`)
  const [, prefix = '', counterCode = '', fyStart = '', fyEnd = '', seq = ''] = match
  return { prefix, counterCode, fiscalYear: `${fyStart}/${fyEnd}`, seq: Number(seq) }
}
